import type { IconSvgObject } from './types';

const CongruentToIcon: IconSvgObject = [
  ["path", { d: "M3.99997 13H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3.99997 19H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3.99997 6.927C6.66664 3.9281 9.3333 4.80578 12 7C14.6666 9.19422 17.3333 10.0719 20 7.073", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default CongruentToIcon;
